<!-- 管理商品 -->

<template>
    <el-container class="Wrapper">
        <el-container class="container">
            <div class="shang">
                <div class="comms">
                    <div class="fens">
                        <el-form :model="searchForm" class="flex flex-wrap gap-2 items-center">
                            <!-- 左移输入框 -->
                            <el-input v-model="searchForm.name" placeholder="请输入商品名称" @keyup.enter="siftsea" class="w-1/4 mr-2"></el-input>
                            <el-select v-if="storeOptions !== ''" v-model="searchForm.storeId" clearable
                                placeholder="请选择门店" @change="StoreSearch" class="w-1/4 mr-2">
                                <el-option v-for="item in storeOptions" :key="item.id" :label="item.name"
                                    :value="item.id" />
                            </el-select>
                            <el-select :collapse-tags="true" v-model="searchForm.categoriesId" multiple
                                placeholder="请选择商品的分类" @change="siftsea" class="fixed-height-select w-1/4 mr-2"
                                max-collapse-tags="1">
                                <el-option v-for="item in classifys" :key="item.value" :label="item.name"
                                    :value="item.id" />
                            </el-select>
                            <!-- 已上架、已下架改为下拉框 -->
                            <el-select v-model="searchForm.productStatus" placeholder="请选择商品状态" @change="siftsea" class="w-1/4 mr-2">
                                <el-option label="已上架" value="1"></el-option>
                                <el-option label="已下架" value="0"></el-option>
                            </el-select>
                            <!-- 添加查找按钮 -->
                            <el-button type="primary" @click="siftsea" style="margin-left: 2vw;">查找</el-button>
                            <el-button type="primary" @click="addsa" class="addproduct">添加商品</el-button>
                            <el-button type="primary" @click="batchShelves" :disabled="selectedRows.length === 0 || hasShelvedProduct">批量上架</el-button>
                            <el-button type="danger" @click="batchTakedown" :disabled="selectedRows.length === 0 || hasTakedownProduct">批量下架</el-button>
                        </el-form>
                    </div>
                    <div class="alluserbody">
                        <el-table v-loading="loading" element-loading-text="加载中，请稍后..."
                            style="width: 100%; margin-left: 10%;" height="85%" :data="management" class="orders"
                            @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="50"></el-table-column>
                            <el-table-column label="序号" width="70">
                                <template v-slot="{ $index }">
                                    {{ $index + 1 }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="name" label="名称" show-overflow-tooltip width="200"/>
                            <el-table-column prop="price" label="价格" width="70">
                            </el-table-column>
                            <el-table-column prop="stock" label="库存" width="80">
                                <template #default="scope">
                                    <el-tag v-if="scope.row.stock <= 1 && scope.row.specStock <= 1" type="error"
                                        style="color: red;">需补货</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="categoriesName" label="所属分类" width="100">
                            </el-table-column>
                            <el-table-column v-if="manage === '0'" prop="storeName" label="所属门店" width="150">
                            </el-table-column>

                            <el-table-column prop="coverUrl" label="图片" width="80">
                                <template #default="scope">
                                    <div class="image-container">
                                        <el-image fit="contain" lazy
                                            :src="`https://199shq.com/api/common/download?name=${scope.row.coverUrl}`"
                                            @click="showPreview(scope.row.coverUrl)" error>
                                            <template #error>
                                                <el-icon>
                                                    <IconPicture />
                                                </el-icon>
                                            </template>
                                        </el-image>
                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column label="修改" width="350px">
                                <template #default="scope">
                                    <el-button type="primary"
                                        @click="goToUpdaStore(scope.row.id, scope.row.name, scope.row.price, scope.row.coverUrl, scope.row.storeName, scope.row.categoriesName, scope.row.storeId, scope.row.commission, scope.row.stock, scope.row.productStatus)">编辑</el-button>
                                    <el-button type="danger" @click="open(scope.row.id)">删除商品</el-button>
                                    <el-button type="primary" @click="openNutritionDialog(scope.row.id)">营养成分</el-button>
									<el-button type="primary" @click="printLabel(scope.row.id, scope.row.name)">打印标签</el-button>
                                    <el-button type="primary" v-if="scope.row.productStatus === 0"
                                        @click="shelves(scope.row.id)">上架</el-button>
                                    <el-button type="primary" v-if="scope.row.productStatus === 1"
                                        @click="takedown(scope.row.id)">下架</el-button>
                                </template>

                                
                                
                            </el-table-column>
                            <!-- 详情列 -->
                            <el-table-column prop="" label="" width="250vw" flexd="right">
                                
                            </el-table-column>
                        </el-table>
                        <!-- 图片预览弹窗 -->
                        <el-image-viewer v-if="showViewer" :initial-index="viewerIndex" :url-list="viewerUrlList"
                            @close="showViewer = false" />
                    </div>
                    <div class="alluserfoots">
                        <div class="demo-pagination-blocks">
                            <el-pagination class="juzhong" v-model:current-page="currentPage4" v-model:page-size="pageSize4"
                                @size-change="handleSizeChangese" @current-change="handleCurrentChangese"
                                :current-page="currentPage4" :page-sizes="[10, 20, 30, 40]" :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper" :total="tatol">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </el-container>
    </el-container>
   <!-- 营养成分弹窗 -->
    <el-dialog v-model="nutritionDialogVisible" title="营养成分详情" width="500px" @close="resetNutritionForm">
        <el-form :model="nutritionForm" label-width="120px">
			<el-form-item label="每份规格">
			<el-input v-model="nutritionForm.portion" placeholder="请输入规格">
			    <template #append>
					<el-select v-model="nutritionForm.portionUnit" placeholder="Select" style="width: 100px">
					    <el-option label="ml" value="ml" />
					    <el-option label="g" value="g" />
					    <el-option label="份" value="份" />
					</el-select>
				</template>
			</el-input>
			</el-form-item>
			<el-form-item label="主要成分">
			<el-input v-model="nutritionForm.foodIngredients" placeholder="请输入食材名称">
			</el-input>
			</el-form-item>
            <el-form-item label="热量">
            <el-input v-model="nutritionForm.calorie" placeholder="请输入热量">
                <template #append>kcal</template>
            </el-input>
            </el-form-item>
            <el-form-item label="蛋白质">
            <el-input v-model="nutritionForm.protein" placeholder="请输入蛋白质">
                <template #append>g</template>
            </el-input>
            </el-form-item>
            <el-form-item label="脂肪">
            <el-input v-model="nutritionForm.fat" placeholder="请输入脂肪">
                <template #append>g</template>
            </el-input>
            </el-form-item>
            <el-form-item label="碳水化合物">
            <el-input v-model="nutritionForm.carbohydrate" placeholder="请输入碳水化合物">
                <template #append>g</template>
            </el-input>
            </el-form-item>
        </el-form>
    
        <div style="margin-top: 20px;">
            <el-alert title="提示" description="请输入产品的营养成分信息，点击保存进行更新。" type="info" show-icon />
        </div>
        
        <template #footer>
            <el-button @click="nutritionDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="saveNutritionData" :loading="savingNutrition">保存</el-button>
        </template>
    </el-dialog>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { toRaw } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import instance from '../network/storester.js';
import { ElMessage, ElMessageBox, ElImageViewer } from 'element-plus';
import { Picture as IconPicture } from '@element-plus/icons-vue';
import { Close } from '@element-plus/icons-vue'


// 添加营养成分相关的响应式变量
const nutritionDialogVisible = ref(false)
const currentNutritionData = ref(null)
const currentProductId = ref(null)

const storeOptions = ref([])
const searchForm = ref({
    name: '',
    categoriesId: [],
    productStatus: '1', // 默认已上架
    storeId: ''
})

// 添加营养成分表单相关的响应式变量
const nutritionForm = ref({
  calorie: '',
  protein: '',
  fat: '',
  carbohydrate: '',
  foodIngredients: '',
  portion: '',
  portionUnit: 'ml'
})
const savingNutrition = ref(false)

const images = ref([])
const image = ref([])
const tatol = ref(0);
const management = ref([]);
const managem = ref(null);
const loading = ref(true)
const router = useRouter();
const input = ref('');
const manage = localStorage.getItem('permissionsStatus');
const value2 = ref(false)
const page = reactive({ pageNum: 1, pageSize: 10 });
const classifys = ref([])
const classify = ref([])
const storeId = ref(0)
const selectedRows = ref([])
const hasShelvedProduct = ref(false)
const hasTakedownProduct = ref(false)
const currentPage4 = ref(1);
const pageSize4 = ref(10);
const showViewer = ref(false);
const viewerUrlList = ref([]); // 支持多张图片浏览
const viewerIndex = ref(0);    // 当前图片索引
const selectedProduct = ref(null);

// 保存营养成分数据
const saveNutritionData = () => {
  if (!currentProductId.value) {
    ElMessage.error('产品ID无效')
    return
  }

  savingNutrition.value = true
  
  // 构造保存数据
  const saveData = {
    "cho": parseFloat(nutritionForm.value.carbohydrate) || 0,          // 碳水化合物
    "energy": parseFloat(nutritionForm.value.calorie) || 0,            // 热量
    "fat": parseFloat(nutritionForm.value.fat) || 0,                   // 脂肪
    "protein": parseFloat(nutritionForm.value.protein) || 0,         // 蛋白质
	"foodIngredients": nutritionForm.value.foodIngredients|| '',
	"portion": nutritionForm.value.portion|| '',
	"portionUnit":nutritionForm.value.portionUnit|| '',
    "isDeleted": 0,
    "na": 0, 
    "productId": currentProductId.value
  }
  
  console.log('准备保存的营养成分数据:', saveData)
  
  // 使用完整的地址保存
  fetch('https://199shq.com/api/productIngredient/save', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(saveData)
  })
    .then(response => {
      console.log('保存响应状态:', response.status)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json()
    })
    .then(data => {
      console.log('保存响应数据:', data)
      
      if (data && (data.state === 20000 || data.code === 200)) {
        ElMessage.success('营养成分保存成功')
        nutritionDialogVisible.value = false
      } else {
        ElMessage.error('保存失败: ' + (data.msg || data.message || '未知错误'))
      }
    })
    .catch(error => {
      console.error('保存营养成分失败:', error)
      ElMessage.error('保存营养成分失败: ' + (error.message || '网络请求失败'))
    })
    .finally(() => {
      savingNutrition.value = false
    })
};

// 重置营养成分表单
const resetNutritionForm = () => {
  nutritionForm.value = {
    calorie: '',
    protein: '',
    fat: '',
    carbohydrate: '',
	foodIngredients: '',
	portion: '',
	portionUnit: 'ml'
  }
};


// 修改获取营养成分数据的函数
const fetchNutritionData = (productId) => {
  loading.value = true
  currentProductId.value = productId // 保存产品ID用于保存操作
  
  instance.get(`/api/productIngredient/list?productId=${productId}`)
    .then(response => {
      console.log('营养成分数据:', response.data)
      
      // 处理返回的数据，填充到表单中
      let nutritionData = null;
      
      if (response.data && response.data.data) {
        if (Array.isArray(response.data.data) && response.data.data.length > 0) {
          nutritionData = response.data.data[0]; // 取第一条数据
        } else if (response.data.data.records && Array.isArray(response.data.data.records) && response.data.data.records.length > 0) {
          nutritionData = response.data.data.records[0]; // 取第一条数据
        } else if (Object.keys(response.data.data).length > 0 && response.data.data.hasOwnProperty('energy')) {
          nutritionData = response.data.data; // 直接使用对象
        }
      }
      
      // 如果有数据则填充表单（包括0值），否则保持空表单
      if (nutritionData) {
        nutritionForm.value.calorie = (nutritionData.energy !== undefined) ? nutritionData.energy : '';
        nutritionForm.value.protein = (nutritionData.protein !== undefined) ? nutritionData.protein : '';
        nutritionForm.value.fat = (nutritionData.fat !== undefined) ? nutritionData.fat : '';
        nutritionForm.value.carbohydrate = (nutritionData.cho !== undefined) ? nutritionData.cho : '';
		nutritionForm.value.foodIngredients = (nutritionData.foodIngredients !== undefined) ? nutritionData.foodIngredients : '';
		nutritionForm.value.portion = (nutritionData.portion !== undefined) ? nutritionData.portion : '';
		nutritionForm.value.portionUnit = (nutritionData.portionUnit !== undefined) ? nutritionData.portionUnit : 'ml';
      } else {
        resetNutritionForm(); // 重置表单
      }
      
      nutritionDialogVisible.value = true;
      loading.value = false;
    })
    .catch(error => {
      console.error('获取营养成分数据失败:', error);
      // 重置表单并显示弹窗，让用户可以填写新的营养成分
      resetNutritionForm();
      nutritionDialogVisible.value = true;
      loading.value = false;
    })
};

// 打开营养成分对话框
const openNutritionDialog = (productId) => {
  fetchNutritionData(productId)
};

//打印标签
const printLabel = (pId,pName) => {
	instance.get(`/api/tproduct/printProductLabel?id=${pId}&name=${pName}`)
	  .then(response => {
	    console.log('已打印标签')
	  })
	  .catch(error => {
	    console.error('打印标签失败:', error);
	  })
};

// 获取店铺选择项
const initStoreOptions = () => {
    if (localStorage.getItem('permissionsStatus') === '0') {
        instance.get('/api/stores')
           .then(response => {
                //console.log('response', response);
                storeOptions.value = response.data;
                //console.log('storeOptions', storeOptions.value);
            })
           .catch(error => {
                //console.log(error);
                ElMessage({
                    showClose: true,
                    message: '请登录',
                    type: 'error',
                })
                router.push('/')
            })
    }

}
const StoreSearch = (value) => {
    if (value === '') {
        storeId.value = 0
        siftsea();
        classifys.value = classify.value
        // initclassifys();
        classifys.value = []
        for (let i = 0; i < classify.value.length; i++) {
            if (classify.value[i].storeId === value) {
                classifys.value.push(classify.value[i])

            }

        }
        siftsea();
    }
}
//获取分类选项
const initclassifys = () => {
    if (localStorage.getItem('permissionsStatus') === '0') {
        instance.get('/api/categories')
           .then(response => {
                classifys.value = response.data;
            })
           .catch(error => {
                ElMessage({
                    showClose: true,
                    message: '请登录',
                    type: 'error',
                })
                router.push('/')
            })
    } else {
        instance.get(`/api/stores/cate/${localStorage.getItem('sysStoreId')}`)

           .then(response => {
                classifys.value = response.data;
            })
           .catch(error => {
                ElMessage({
                    showClose: true,
                    message: '请登录',
                    type: 'error',
                })
                router.push('/')
            })
    }

}
const handleSizeChangese = (val) => {
    page.pageSize = val;
    //console.log(val);
    // if (value2.value === true) {
    //     offshelf()
    //     return
    // }
    loading.value = true;
    siftsea();
};
//当前页改变时触发
const handleCurrentChangese = (val) => {
    page.pageNum = val;
    // if (value2.value === true) {
    //     offshelf()
    //     return
    // }
    loading.value = true;
    siftsea();
};
const productStatus = ref('')
const siftsea = () => {
    productStatus.value = searchForm.value.productStatus;
    if (localStorage.getItem('permissionsStatus') === '0') {
        // value2.value = false
        // input.value = ''
        if (searchForm.value.storeId !== '') {
            storeId.value = searchForm.value.storeId
        }
        const data = {
            // pageNum: page.pageNum,
            // pageSize: page.pageSize,
            // name: searchForm.value.name,
            // categoriesIds: searchForm.value.categoriesId,
            // productStatus: productStatus.value,
            // storeId: searchForm.value.storeId,
            // currLimit:''
            "categoriesIds": searchForm.value.categoriesId,
            // "currLimit": "",
            "name": searchForm.value.name,
            "pageNum": page.pageNum,
            "pageSize": page.pageSize,
            "productStatus": productStatus.value,
            "storeId": storeId.value
        }
        instance.post(`/api/tproduct/list`, data)
           .then(response => {
                //console.log('response', response)
                managem.value = response.data.data.allProductInfo;
                management.value = toRaw(managem.value);
                tatol.value = response.data.data.totalCount
                //console.log(management.value);

                loading.value = false;
                //console.log(images.value);
                //console.log(image.value);
            }).catch(error => {
                //console.log(error);
                ElMessage({
                    showClose: true,
                    message: '请登录',
                    type: 'error',
                })
                // router.push('./')
            })

    } else {

        const data = {
            pageNum: page.pageNum,
            pageSize: page.pageSize,
            name: searchForm.value.name,
            categoriesIds: searchForm.value.categoriesId,
            productStatus: productStatus.value,
            storeId: localStorage.getItem('sysStoreId')
        }
        instance.post(`/api/tproduct/list`, data)
           .then(response => {
                managem.value = response.data.data.allProductInfo;
                management.value = toRaw(managem.value);
                tatol.value = response.data.data.totalCount
                //console.log(management.value);

                loading.value = false;
                //console.log(management.value);
                //console.log(management.value);
            }).catch(error => {
                //console.log(error);
                ElMessage({
                    showClose: true,
                    message: '请登录',
                    type: 'error',
                })
                router.push('./')
            })
    }
}


async function fetchData() {

    //console.log(image.value);
    image.value.splice(0, image.value.length);
    // image.value = []
    for (let j = 0; j < images.value.length; j++) {
        //console.log('111');
        try {
            const response = await instance.get(`/api/common/download?name=${images.value[j]}`);
            //console.log('333');
            image.value.splice(j, image.value.length);
            image.value.push(response.request.responseURL);
        } catch (error) {
            //console.log(error);
        }
    }
    //console.log(image.value);
}



const goToUpdaStore = (id, name, price, images, storeName, categoriesName, storeId, commission, stock, productStatus) => {
    if (localStorage.getItem('permissionsStatus') === '0') {
        router.push({
            path: '/editproduct',
            // name: 'home',
            query: {
                msg: id,
                name: name,
                price: price,
                images: images,
                storeName: storeName,
                categoriesName: categoriesName,
                storeId: storeId,
                commission: commission,
                stock: stock,
                productStatus: productStatus,
            }
        })
    } else {
        router.push({
            path: '/editproduct',
            // name: 'home',
            query: {
                msg: id,
                name: name,
                price: price,
                images: images,
                storeName: storeName,
                categoriesName: categoriesName,
                storeId: localStorage.getItem('sysStoreId'),
                commission: commission,
                stock: stock,
                productStatus: productStatus,
            }
        })
    }

}
// const detail = (id) => {
//     //console.log(id);
//     router.push({
//         path: '/productdetails',
//         query: {
//             msg: id
//         }
//     })
// };
const takedown = (id) => {
    const product = management.value.find(item => item.id === id);
    if (product) {
        selectedProduct.value = product;
    } else {
        selectedProduct.value = null;
        ElMessage.warning('未找到对应的商品详情');
    }
    ElMessageBox.confirm(
        '您确定要下架该商品吗?',
        '提示',
        {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
        }
    ).then(() => {
            instance.put(`/api/tproduct/status/${id}`)
               .then(response => {
                    loading.value = true
                    //console.log(response);
                    ElMessage({
                        type: 'success',
                        message: `下架成功`,
                    })
                    siftsea();
                })

        }).catch(() => {
            ElMessage({
                type: 'info',
                message: '取消下架',
            })
        })
}
const shelves = (id) => {
    ElMessageBox.confirm(
        '您确定要上架该商品吗?',
        '提示',
        {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
        }
    ).then(() => {
            instance.put(`/api/tproduct/status/${id}`)
               .then(response => {
                    loading.value = true
                    //console.log(response);
                    ElMessage({
                        type: 'success',
                        message: `上架成功`,
                    })
                    siftsea();
        })
       .catch(() => {
            ElMessage({
                type: 'info',
                message: '取消上架',
            })
        })
	})
}

const open = (id) => {
    ElMessageBox.confirm(
        '您确定要删除该商品吗?',
        '提示',
        {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
        }
    ).then(() => {
            instance.delete(`/api/tproduct/forcedDeletion/${id}`)
               .then(response => {
                    loading.value = true
                    ElMessage({
                        type: 'success',
                        message: '删除成功',
                    })
                    siftsea();
                }).catch((error) => {
                    ElMessage({
                        type: 'info',
                        message: '取消删除',
                    })
                })
        })
}
// const DeleteDetails = (id) => {

//     ElMessageBox.confirm(
//         '您确定要删除该商品详情吗?',
//         '提示',
//         {
//             confirmButtonText: '确认',
//             cancelButtonText: '取消',
//             type: 'warning',
//         }
//     ).then(() => {
//             instance.delete(`/api/productVideo/${id}`)
//             instance.delete(`/api/details/${id}`)
//         .then(response => {

//                     loading.value = true
//                     ElMessage({
//                         type: 'success',
//                         message: '删除成功',
//                     })
//                     siftsea();
//                 }).catch((error) => {
//                     //console.log(error);
//                 })
//         })
//        .catch(() => {

//             ElMessage({
//                 type: 'info',
//                 message: '取消删除',
//             })
//         })
// }
const addsa = () => {
    router.push('../AllProducts')
}

const batchShelves = () => {
    const ids = selectedRows.value.map(row => row.id)
    ElMessageBox.confirm(
        '您确定要批量上架这些商品吗?',
        '提示',
        {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
       .then(() => {
            Promise.all(ids.map(id => instance.put(`/api/tproduct/status/${id}`)))
               .then(() => {
                    loading.value = true
                    ElMessage({
                        type: 'success',
                        message: `批量上架成功`,
                    })
                    siftsea();
                }).catch(error => {
                    ElMessage({
                        type: 'error',
                        message: '批量上架失败',
                    })
                })
        }).catch(() => {
            ElMessage({
                type: 'info',
                message: '取消批量上架',
            })
        })
}

const batchTakedown = () => {
    const ids = selectedRows.value.map(row => row.id)
    ElMessageBox.confirm(
        '您确定要批量下架这些商品吗?',
        '提示',
        {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
        }
    ).then(() => {
            Promise.all(ids.map(id => instance.put(`/api/tproduct/status/${id}`)))
               .then(() => {
                    loading.value = true
                    ElMessage({
                        type: 'success',
                        message: `批量下架成功`,
                    })
                    siftsea();
                }).catch(error => {
                    ElMessage({
                        type: 'error',
                        message: '批量下架失败',
                    })
                })
        }).catch(() => {
            ElMessage({
                type: 'info',
                message: '取消批量下架',
            })
        })
}

const handleSelectionChange = (rows) => {
    selectedRows.value = rows
    hasShelvedProduct.value = rows.some(row => row.productStatus === 1)
    hasTakedownProduct.value = rows.some(row => row.productStatus === 0)
}

//显示图片预览
const showPreview = (coverUrl) => {
    if (!coverUrl) {
        ElMessage.warning('暂无图片可预览');
        return;
    }

    // 单图预览：直接设置数组和索引
    viewerUrlList.value = [`https://199shq.com/api/common/download?name=${coverUrl}`];
    viewerIndex.value = 0;
    showViewer.value = true;
};

//设置分类
onMounted(() => {
    siftsea()
    initclassifys()
    initStoreOptions()
})
</script>
<style>
.leftnavbar {
    position: fixed;
    top: 0;
    left: 0;
    width: 15vw;
    height: 100vh;
    background-color: #545c64;
}

.container {
    position: fixed;
    top: 0;
    left: 15vw;
}

.container_top {
    width: 85vw;
    height: 10vh;
    background-color: #545c64;
}

.main {
    position: fixed;
    top: 10vh;
    left: 11vw;
    width: 85vw;
    height: 90vh;
}

.orders {
    position: fixed;
    margin-top: 15vh;
    left: 8vw;
}

.fens .el-select {
    width: 14vw;
    font-size: 12px;
    margin-left: 10px;
}

.comms .el-table {
    position: fixed;
    top: 6%;
    left: 1%;
}

.comms .el-table tr.el-table__row {
    height: 65px !important;
    font-size: 12px !important;
}



.shang {
    /* width: 85%; */
    font-size: 12px !important;
}

.el-table {
    width: 100%;
}

.el-table__header-wrapper table,
.el-table__body-wrapper table {
    width: 100% !important;
}

.el-table__body,
.el-table__footer,
.el-table__header {
    table-layout: auto;
}

.addproduct {
    position: fixed;
    top: 14vh;
    right: 20vw;
}

.addproducts {
    position: fixed;
    top: 14vh;
    right: 15vw;
}

.fens {
    position: fixed;
    top: 13vh;
    z-index: 1;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    left:11vw;
}

.fens .el-input {
    width: 15vw;
}

/* .fens .switchs {
    left: 30vw;
} */

.alluserfoots .demo-pagination-blocks {
    position: fixed;
    width: 85vw;
    top: 94vh;
    height: 10vh;
    /* background-color: red; */
}

.image-container {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: 4px;
    background-color: #f5f7fa;
}

.product-detail {
    margin-top: 20px;
    padding: 15px;
    border: 1px solid #e4e4e4;
    background-color: #f9f9f9;
}

.product-detail-card {
    margin-top: 15px;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease-in-out;
}

.card-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-size: 16px;
    color: #333;
}

.card-body p {
    margin: 8px 0;
    font-size: 14px;
    color: #555;
}

.image-preview {
    margin-top: 10px;
}

.close-detail-btn {
    background-color: #ff4d4f;
    color: white;
    transition: all 0.3s ease-in-out;
}

.close-detail-btn:hover {
    background-color: #ff7875;
}
</style>
